import {
    ChevronRightIcon, CogIcon, HeroBeakerIcon, HeroCalendarDaysIcon,
} from 'components/Icon/Icon'

import {
    ItemDisplayType, NestedDefaultMenuBarProps,
} from './types'

import Button from 'components/Button'
import {Icon} from 'components/Icon/types'

import React from 'react'

import {chevronWrapper} from '../styles/Menubar'
import {navigation} from 'navigation'
import {styled} from 'stitches/config'
// import {useAppSelector} from 'hooks'
import {useTranslation} from 'react-i18next'

const StyledChevronWrapper = styled('div', chevronWrapper)


export const DefaultMenuBarQueueSettings = (props: NestedDefaultMenuBarProps<'QueueSettings'> & {queueId: string}) => {
    const {
        params, type, queueId,
    } = props
    const {t} = useTranslation()

    const showSchedule = params.tab === 'schedule'
    const showAdvenced = params.tab === 'advanced'

    return (
        <>
            {/* eslint-disable-next-line no-extra-parens */}
            {(type === ItemDisplayType.middleItems && (params?.tab)) || type === ItemDisplayType.all || (type === ItemDisplayType.lastItem && !params?.tab) ?
                <>
                    {type !== ItemDisplayType.middleItems && <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>}
                    <Button
                        color='text'
                        iconLeft={CogIcon}
                        onPress={() => navigation.push('QueueSettings', {queue_id: queueId})}
                        text={t('Queue settings')}
                    />
                </>
                : null}
            {type === ItemDisplayType.lastItem || type === ItemDisplayType.all ?

                <>
                    {
                        showSchedule ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroCalendarDaysIcon as unknown as Icon}
                                    onPress={() => navigation.push('QueueSettings', {
                                        queue_id: queueId,
                                        tab: 'schedule',
                                    })}
                                    text={t('Schedule')}
                                />
                            </>
                            : null
                    }
                    {
                        showAdvenced ?
                            <>
                                <StyledChevronWrapper><ChevronRightIcon /></StyledChevronWrapper>
                                <Button
                                    color='text'
                                    iconLeft={HeroBeakerIcon as unknown as Icon}
                                    onPress={() => navigation.push('QueueSettings', {
                                        queue_id: queueId,
                                        tab: 'advanced',
                                    })}
                                    text={t('Advanced settings')}
                                />
                            </>
                            : null
                    }
                </>
                : null }
        </>
    )
}
